var map = {
	"./dev": [
		679,
		41
	],
	"./dev.ts": [
		679,
		41
	],
	"./local": [
		680,
		42
	],
	"./local.ts": [
		680,
		42
	],
	"./prod": [
		681,
		43
	],
	"./prod.ts": [
		681,
		43
	],
	"./prodfunk": [
		682,
		44
	],
	"./prodfunk.ts": [
		682,
		44
	],
	"./prodzurich": [
		683,
		45
	],
	"./prodzurich.ts": [
		683,
		45
	],
	"./stage": [
		684,
		46
	],
	"./stage.ts": [
		684,
		46
	],
	"./stagezurich": [
		685,
		47
	],
	"./stagezurich.ts": [
		685,
		47
	],
	"./test": [
		686,
		48
	],
	"./test.ts": [
		686,
		48
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 976;
module.exports = webpackAsyncContext;